/**
 * The public /developers page: the same documentation browser the app shows
 * in Settings, reachable without signing in so a hosted model or a teammate
 * can read how to connect before holding a credential.
 */
import { LogoMark, Wordmark } from "@/ui/Logo";
import { DocsBrowser } from "./DocsBrowser";
import s from "./developers.module.css";

export function DevelopersPage() {
  return (
    <div className={s.page} data-developers-page>
      <header className={s.pageHead}>
        <a href="/" aria-label="Hydra Notes" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <LogoMark size={22} />
          <Wordmark size={14} />
        </a>
        <span className={s.pageTitle}>Developers</span>
        <span className={s.spacer} />
        <a className={s.pageLink} href="/api/v1/openapi.json">
          OpenAPI
        </a>
        <a className={s.pageLink} href="/api/v1/docs.md">
          Markdown
        </a>
        <a className={s.pageLink} href="/app">
          Open the app
        </a>
      </header>
      <div className={s.pageBody}>
        <DocsBrowser initial={{ kind: "guide", id: "start" }} />
      </div>
    </div>
  );
}
